import AutoLogout from "./components/AutoLogout.js";
import { useUserContext } from "./contexts/UserContext.js";

// react router (Data Router API)
import { createBrowserRouter, RouterProvider, Outlet } from "react-router-dom";
import PrivateRoute from "./PrivateRoutes/PrivateRoute.js";

// pages
import Home from "./pages/Home";
import Login from "./pages/Login";
import NewSample from "./pages/NewSample";
import RecentSamples from "./pages/RecentSamples";
import ViewSample from "./pages/ViewSample";
import Unauthorized from "./pages/Unauthorized";
import Map from "./pages/Map";
import Profile from "./pages/Profile.js";
import ResetPassword from "./pages/ResetPassword.js";

function RootLayout() {
  const { user } = useUserContext();
  return (
    <>
      {user.isAuthenticated && <AutoLogout />}
      <Outlet />
    </>
  );
}

const router = createBrowserRouter([
  {
    element: <RootLayout />,
    children: [
      {
        path: "/",
        element: (
          <PrivateRoute>
            <Home />
          </PrivateRoute>
        ),
      },
      { path: "/login", element: <Login /> },
      { path: "/reset-password/:token", element: <ResetPassword /> },
      {
        path: "/new",
        element: (
          <PrivateRoute>
            <NewSample />
          </PrivateRoute>
        ),
      },
      {
        path: "/recent",
        element: (
          <PrivateRoute>
            <RecentSamples />
          </PrivateRoute>
        ),
      },
      {
        path: "/profile/:id",
        element: (
          <PrivateRoute>
            <Profile />
          </PrivateRoute>
        ),
      },
      {
        path: "/sample/:id",
        element: (
          <PrivateRoute>
            <ViewSample />
          </PrivateRoute>
        ),
      },
      { path: "/unauthorized", element: <Unauthorized /> },
      {
        path: "/map",
        element: (
          <PrivateRoute requiredRoles={["admin"]} requiredTiers={["premium"]}>
            <Map />
          </PrivateRoute>
        ),
      },
    ],
  },
]);

export default function AppRoutes() {
  return <RouterProvider router={router} />;
}
